import { useMemo } from 'react';
import { useBiLogger } from '@wix/cli-telemetry-react';
import { wixCliAppBiEvents } from './events.js';

export function useWixCliAppBi() {
  const biLogger = useBiLogger();
  return useMemo(() => wixCliAppBiEvents(biLogger), [biLogger]);
}
